import * as selectors from "./userProfile.selectors";
import * as asyncActions from "./userProfile.actions";
import * as slice from "./userProfile.reducers";

export const {
  name,
  actions: {
    setAwsToken,
    setIsAuthenticated,
    setShouldFetchUser,
  },
  reducer,
} = slice;

export const { updateUserProfile, fetchUserProfileById, fetchInvitedUsers } = asyncActions;

export const {
  selectUser,
  getAWSToken,
  selectIsAuthenticated,
  selectShouldFetchUser,
} = selectors;
